import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref } from "vue";
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import AppPageHeader from "@/components/app/AppPageHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

const store = useStore()

const model = ref<{ email: string, password: string }>({ email: '', password: '' })

const lock = reactive<{ formSubmitting: boolean }>({ formSubmitting: false })

const router = useRouter()

async function submit (): Promise<void> {
  await store.dispatch('auth/login', model.value)

  await router.push({ name: 'home' })
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppPageHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Sign in")
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "header"),
    _createVNode(_component_FormKit, {
      id: "signin",
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      type: "form",
      name: "sign-in",
      actions: false,
      onSubmit: submit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          id: "email",
          type: "email",
          label: "Email",
          name: "email",
          help: "This is email",
          autocomplete: "username",
          disabled: lock.formSubmitting,
          required: "",
          "outer-class": "mb-3"
        }, null, 8, ["disabled"]),
        _createVNode(_component_FormKit, {
          type: "password",
          label: "Password",
          name: "password",
          help: "This is password",
          autocomplete: "current-password",
          disabled: lock.formSubmitting,
          required: "",
          "outer-class": "mb-3"
        }, null, 8, ["disabled"]),
        _createVNode(_component_FormKit, {
          type: "submit",
          "input-class": "btn btn-sm btn-primary btn-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(FormKitSubmitButtonContent, null, {
              default: _withCtx(() => [
                _createTextVNode("Sign in")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _renderSlot(_ctx.$slots, "footer")
  ], 64))
}
}

})